import {observer} from 'mobx-react';
import {PanelTooltip} from 'shared/components';

const Note = observer(({model}) => {
  if (!model.hasNote) return null;

  return (
    <div className='relative'>
      <PanelTooltip icon='description'>{model.note}</PanelTooltip>
    </div>
  );
});

export default Note;
